'use client';

import { useEffect } from 'react';
import { init, setUserId } from '@/lib/log';
import { useUserInfoStore } from '@/models/userInfo';

/**
 * A client-side component to initialize Amplitude analytics.
 * It runs only in the browser and renders nothing.
 */
export default function AmplitudeInitializer() {
  const { userInfo } = useUserInfoStore();
  useEffect(() => {
    console.log('AmplitudeInitializer');
    // Initialize Amplitude once when the component mounts.
    init();
    console.log('Amplitude initialized');
  }, []);
  useEffect(() => {
    if (userInfo.userid) {
      setUserId(userInfo.userid.toString());
    }
  }, [userInfo.userid]);

  return null;
}
